import { type RuntimeContext } from '@blaze-shared/elements-domain';
import { MAIN_INPUT_NAME } from '@blaze-shared/workflow-domain';

/**
 * Finds the id of the row a dataset node is acting on, or `''` when the context carries none.
 *
 * `detailsView` has to be the final fallback: a details view can host, say, a table bound to a
 * different dataset, and the actions on that table then act on a different row than the details
 * view itself. `||` rather than `??` so that an empty id falls through to the next candidate.
 */
export function getRowId(idColumnName: string, context: RuntimeContext): string {
  return (
    context?.['form']?.[idColumnName] ||
    context?.[MAIN_INPUT_NAME]?.[idColumnName] ||
    context?.['detailsView']?.[idColumnName] ||
    ''
  );
}
